import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Icon from "@/components/Icon";

const Container = ({ children, className = "" }) => <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
const STEPS = [
  { icon: "MousePointerClick", t: "Exprimez votre besoin", d: "Sélectionnez vos services et décrivez votre besoin, avec ou sans compte. Vous pouvez indiquer des dates souhaitées pour les missions horaires." },
  { icon: "CalendarCheck", t: "Nous vérifions les disponibilités", d: "Notre équipe analyse votre demande et vérifie la capacité réelle. L'envoi d'une demande ne constitue pas une confirmation automatique." },
  { icon: "UserCheck", t: "Attribution de la mission", d: "Une professionnelle disponible est attribuée à votre mission, puis celle-ci est confirmée." },
  { icon: "Headset", t: "Nous prenons le relais", d: "Votre secrétariat est géré à distance. Vous suivez tout depuis votre espace client et communiquez directement avec nous." },
];

export default function HowItWorks() {
  const navigate = useNavigate();
  return (
    <div className="py-16 md:py-20">
      <Container>
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Comment ça marche</span>
        <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-4xl sm:text-5xl">Un accompagnement simple, étape par étape</h1>
        <div className="mt-12 space-y-6">
          {STEPS.map((s, i) => (
            <div key={i} className="flex gap-5 bg-white rounded-xl border border-slate-200 p-6">
              <div className="flex flex-col items-center">
                <span className="h-10 w-10 rounded-full bg-primary text-white font-bold flex items-center justify-center font-mono-metric">{i + 1}</span>
                {i < STEPS.length - 1 && <span className="w-px flex-1 bg-slate-200 mt-2" />}
              </div>
              <div className="pb-2">
                <div className="flex items-center gap-2"><Icon name={s.icon} className="h-5 w-5 text-accent" /><h3 className="font-heading font-semibold text-lg text-slate-900">{s.t}</h3></div>
                <p className="mt-2 text-slate-600 leading-relaxed">{s.d}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-10"><Button size="lg" className="bg-primary" onClick={() => navigate("/demande")}>Faire une demande</Button></div>
      </Container>
    </div>
  );
}
